const config = {
  basename:'self-agentonboarding',
  defaultPath: '/product/dashboard',
  fontFamily: `Inter`,
  borderRadius: 12
};

export default config;